import React, { useRef } from "react";
import "./NewBooking.css";
import TextField from "@mui/material/TextField";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import FormHelperText from "@mui/material/FormHelperText";
import Select from "@mui/material/Select";
import { useState } from "react";
import { useEffect } from "react";
import Button from "@mui/material/Button";
import Autocomplete from "@mui/material/Autocomplete";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";

import startPoint from "../../../Assets/Pin_icon_green50.png";
import endPoint from "../../../Assets/Pin_icon50.png";

import useHttp from "../../../Hooks/use-http";
import Message from "../../../Modal/Message";
import { InputAdornment } from "@mui/material";
import { CountriesCode } from "./CountriesCode";
import MobileNumberFieldWithCountryCode from "../../CommonComponent/MobileNumberFieldWithCountryCode";

let today = new Date();
const yyyy = today.getFullYear();
let dd = new Date(
  today.getFullYear(),
  today.getMonth(),
  today.getDate() + 2
).getDate();
let mm = new Date(
  today.getFullYear(),
  today.getMonth(),
  today.getDate() + 2
).getMonth();

if (dd < 10) dd = "0" + dd;
if (mm < 10) mm = "0" + mm;

Date.prototype.addHours = function (h) {
  this.setTime(this.getTime() + h * 60 * 60 * 1000);
  return this;
};
Date.prototype.addMinutes = function (m) {
  this.setTime(this.getTime() + m * 60 * 1000);
  return this;
};

const formattedOvermorrow = yyyy + "-" + mm + "-" + dd;

const Dates = ["Today", "Tomorrow", formattedOvermorrow];
const packageList = ["8hrs 80km", "12hrs 120km"];
const times = [];
let guestDetails = {
  name: "",
  number: "",
};

let bookingDetails = {
  pickup: "",
  drop: "",
  date: "",
  time: "",
  package: "",
  pickupLat: "",
  pickupLng: "",
  dropLat: "",
  dropLng: "",
};
let autocomplete = [];
let errorFileds = {
  guestNameError: "",
  guestNumberError: "",
  pickupLocationError: "",
  dropLocationEror: "",
  pickupDateError: "",
  pickupTimeError: "",
  rentalPackageError: "",
  vehicleTypeError: "",
};
let isError = false;
let corporatesData = [];
let selectedCorporateDetails = [];
let map = null;
let pickupMarker = null;
let dropMarker = null;
let routePolyline = null;

const NewBooking = () => {
  const pickupInputRef = useRef();
  const dropInputRef = useRef();
  const [tripDate, setTripDate] = useState();
  const [tripTime, setTripTime] = useState();
  const guestNameInputRef = useRef();
  const guestNumberInputRef = useRef();
  const [cabBookingClicked, setCabBookingClicked] = useState(false);
  const [packageType, setPackageType] = useState();
  const [isConfirmRide, setIsConfirmRide] = useState(false);
  const [formError, setFormError] = useState(errorFileds);
  const [isBookingSuccess, setIsBookingSuccess] = useState(false);
  const [servicesTabbarValue, setServicesTabbarValue] = useState(0);
  const [isOTPEnabled, setIsOtpEnabled] = useState(true);
  const [isdCode, setIsdCode] = useState("91");
  const [mapInitialized, setMapInitialized] = useState(false);

  const coroprateLists = (data) => {
    let tempArr = [];

    data?.corporates
      ?.filter((cp) => cp.parentID == null)
      .forEach((cp, i) => {
        tempArr[i] = {};
        tempArr[i].cpName = cp.name;
        tempArr[i].cpId = cp.corporateID;

        tempArr[i].adminDptId =
          cp.DepartmentID?.split(",")[
            cp.DepartmentName.toLowerCase()
              .split(",")
              .findIndex((item) => item.trim() === "admin")
          ];
      });

    corporatesData = tempArr;
  };

  const corporateNameClickHandler = (e, corporateDetails) => {
    if (corporateDetails) {
      selectedCorporateDetails = corporateDetails;
    } else selectedCorporateDetails = [];
  };

  // Initialize map and autocomplete
  useEffect(() => {
    if (!mapInitialized) {
      const script = document.createElement("script");
      script.src =
        "https://maps.googleapis.com/maps/api/js?key=AIzaSyDHdkmGjsfNqasFs6m9CooShFZsqWHcdUs&callback=scheduleInitMap&libraries=places&v=weekly";
      script.async = true;
      document.body.appendChild(script);
      setMapInitialized(true);
    }
  }, [mapInitialized]);

  function initMap() {
    // Initialize map
    const mapElement = document.getElementById("schedule-booking-map");
    if (!mapElement) return;

    map = new window.google.maps.Map(mapElement, {
      center: { lat: 23.0225, lng: 72.5714 }, // Ahmedabad center
      zoom: 12,
      disableDefaultUI: false,
      zoomControl: true,
      fullscreenControl: true,
    });

    // Initialize autocomplete for pickup
    const input1 = document.getElementById("pac-input1");
    if (input1) {
      autocomplete[0] = new window.google.maps.places.Autocomplete(input1, {
        componentRestrictions: { country: ["in"] },
      });

      autocomplete[0].addListener("place_changed", () => {
        const place = autocomplete[0].getPlace();
        if (place.geometry) {
          bookingDetails.pickup = place.formatted_address || place.name;
          bookingDetails.pickupLat = place.geometry.location.lat();
          bookingDetails.pickupLng = place.geometry.location.lng();

          // Update pickup marker
          if (pickupMarker) {
            pickupMarker.setPosition(place.geometry.location);
          } else {
            pickupMarker = new window.google.maps.Marker({
              position: place.geometry.location,
              map: map,
              icon: startPoint,
              title: "Pickup Location",
            });
          }

          // Update map bounds
          updateMapBounds();
          updateDirectLine();

          // Clear error
          setFormError((prev) => ({
            ...prev,
            pickupLocationError: "",
          }));
        }
      });
    }

    // Initialize autocomplete for drop
    const input2 = document.getElementById("pac-input2");
    if (input2) {
      autocomplete[1] = new window.google.maps.places.Autocomplete(input2, {
        componentRestrictions: { country: ["in"] },
      });

      autocomplete[1].addListener("place_changed", () => {
        const place = autocomplete[1].getPlace();
        if (place.geometry) {
          bookingDetails.drop = place.formatted_address || place.name;
          bookingDetails.dropLat = place.geometry.location.lat();
          bookingDetails.dropLng = place.geometry.location.lng();

          // Update drop marker
          if (dropMarker) {
            dropMarker.setPosition(place.geometry.location);
          } else {
            dropMarker = new window.google.maps.Marker({
              position: place.geometry.location,
              map: map,
              icon: endPoint,
              title: "Drop Location",
            });
          }

          // Update map bounds
          updateMapBounds();
          updateDirectLine();

          // Clear error
          setFormError((prev) => ({
            ...prev,
            dropLocationEror: "",
          }));
        }
      });
    }
  }
  window.scheduleInitMap = initMap;

  const updateMapBounds = () => {
    if (!map) return;

    const bounds = new window.google.maps.LatLngBounds();
    if (pickupMarker) {
      bounds.extend(pickupMarker.getPosition());
    }
    if (dropMarker) {
      bounds.extend(dropMarker.getPosition());
    }

    if (!bounds.isEmpty()) {
      const padding = 50;
      map.fitBounds(bounds, {
        top: padding,
        right: padding,
        bottom: padding,
        left: padding,
      });
    } else if (pickupMarker) {
      // If only pickup is selected, center on it
      map.setCenter(pickupMarker.getPosition());
      map.setZoom(15);
    } else if (dropMarker) {
      // If only drop is selected, center on it
      map.setCenter(dropMarker.getPosition());
      map.setZoom(15);
    }
  };

  // Bézier curve calculation function
  const calculateBezierPoint = (t, p0, p1, p2) => {
    const u = 1 - t;
    const tt = t * t;
    const uu = u * u;
    
    return {
      lat: uu * p0.lat + 2 * u * t * p1.lat + tt * p2.lat,
      lng: uu * p0.lng + 2 * u * t * p1.lng + tt * p2.lng,
    };
  };

  const updateDirectLine = () => {
    if (!map || !pickupMarker || !dropMarker || servicesTabbarValue == 2) {
      return;
    }

    // Remove existing polyline if any
    if (routePolyline) {
      routePolyline.setMap(null);
    }

    // Get positions
    const pickupPos = pickupMarker.getPosition();
    const dropPos = dropMarker.getPosition();
    
    // Start point (pickup)
    const p0 = {
      lat: pickupPos.lat(),
      lng: pickupPos.lng(),
    };
    
    // End point (drop)
    const p2 = {
      lat: dropPos.lat(),
      lng: dropPos.lng(),
    };
    
    // Calculate midpoint
    const midLat = (p0.lat + p2.lat) / 2;
    const midLng = (p0.lng + p2.lng) / 2;
    
    // Calculate distance and direction
    const latDiff = p2.lat - p0.lat;
    const lngDiff = p2.lng - p0.lng;
    const distance = Math.sqrt(latDiff * latDiff + lngDiff * lngDiff);
    
    // Control point for Bézier curve (perpendicular offset from midpoint)
    const curveHeight = distance * 0.4; // Adjust this to control curve height
    const angle = Math.atan2(lngDiff, latDiff) + Math.PI / 2; // Perpendicular angle
    
    const p1 = {
      lat: midLat + Math.cos(angle) * curveHeight,
      lng: midLng + Math.sin(angle) * curveHeight,
    };
    
    // Generate points along the Bézier curve
    const numPoints = 50; // Number of points for smooth curve
    const path = [];
    
    for (let i = 0; i <= numPoints; i++) {
      const t = i / numPoints;
      const point = calculateBezierPoint(t, p0, p1, p2);
      path.push(point);
    }

    routePolyline = new window.google.maps.Polyline({
      path: path,
      geodesic: true,
      strokeColor: "#00b0ff",
      strokeOpacity: 1.0,
      strokeWeight: 4,
    });

    routePolyline.setMap(map);
  };

  const { isLoading, sendRequest } = useHttp();

  useEffect(() => {
    sendRequest(
      {
        url: "/corporates",
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: {
          emailID: localStorage.getItem("user"),
        },
      },
      coroprateLists
    );
  }, [sendRequest]);

  const rideStatus = (data) => {
    if (data.status == 200 || data.status == 201) {
      // Reset form
      autocomplete = [];
      guestDetails.name = "";
      guestDetails.number = "";
      bookingDetails = {
        pickup: "",
        drop: "",
        date: "",
        time: "",
        package: "",
        pickupLat: "",
        pickupLng: "",
        dropLat: "",
        dropLng: "",
      };
      setTripDate("");
      setTripTime("");
      setCabBookingClicked(false);
      setPackageType("");
      setIsOtpEnabled(true);

      // Clear markers
      if (pickupMarker) {
        pickupMarker.setMap(null);
        pickupMarker = null;
      }
      if (dropMarker) {
        dropMarker.setMap(null);
        dropMarker = null;
      }
      if (routePolyline) {
        routePolyline.setMap(null);
        routePolyline = null;
      }

      // Clear input fields
      if (pickupInputRef.current) pickupInputRef.current.value = "";
      if (dropInputRef.current) dropInputRef.current.value = "";
      if (guestNameInputRef.current) guestNameInputRef.current.value = "";
      if (guestNumberInputRef.current) guestNumberInputRef.current.value = "";

      setIsBookingSuccess("success");
    } else setIsBookingSuccess("error");
    setIsConfirmRide(false);
  };

  useEffect(() => {
    if (isConfirmRide) {
      isError = false;
      
      // Validate all fields
      if (!guestDetails.name) {
        isError = true;
        setFormError((prev) => ({
          ...prev,
          guestNameError: "Please enter valid name",
        }));
      }
      if (!guestDetails.number) {
        isError = true;
        setFormError((prev) => ({
          ...prev,
          guestNumberError: "Please enter valid Number",
        }));
      }
      if (!bookingDetails.pickup) {
        isError = true;
        setFormError((prev) => ({
          ...prev,
          pickupLocationError: "Please enter valid location",
        }));
      }
      if (!bookingDetails.drop && servicesTabbarValue != "2") {
        isError = true;
        setFormError((prev) => ({
          ...prev,
          dropLocationEror: "Please enter valid location",
        }));
      }
      if (!bookingDetails.date) {
        isError = true;
        setFormError((prev) => ({
          ...prev,
          pickupDateError: "Please select valid date",
        }));
      }
      if (!bookingDetails.time) {
        isError = true;
        setFormError((prev) => ({
          ...prev,
          pickupTimeError: "Please select valid time",
        }));
      }
      if (!cabBookingClicked) {
        isError = true;
        setFormError((prev) => ({
          ...prev,
          vehicleTypeError: "Please select a vehicle type",
        }));
      }
      if (!bookingDetails.package && servicesTabbarValue == "2") {
        isError = true;
        setFormError((prev) => ({
          ...prev,
          rentalPackageError: "Please select valid package",
        }));
      }

      if (isError) {
        setIsConfirmRide(false);
        return;
      }

      // Get coordinates from autocomplete or markers
      if (autocomplete[0]?.getPlace()?.geometry) {
        bookingDetails.pickupLat = autocomplete[0].getPlace().geometry.location.lat();
        bookingDetails.pickupLng = autocomplete[0].getPlace().geometry.location.lng();
      } else if (pickupMarker) {
        const pos = pickupMarker.getPosition();
        bookingDetails.pickupLat = pos.lat();
        bookingDetails.pickupLng = pos.lng();
      }

      if (autocomplete[1]?.getPlace()?.geometry) {
        bookingDetails.dropLat = autocomplete[1].getPlace().geometry.location.lat();
        bookingDetails.dropLng = autocomplete[1].getPlace().geometry.location.lng();
      } else if (dropMarker) {
        const pos = dropMarker.getPosition();
        bookingDetails.dropLat = pos.lat();
        bookingDetails.dropLng = pos.lng();
      }

      let flag = tripTime.includes("PM") && tripTime.split(":")[0] != 12;
      let convertedTime =
        (flag ? +tripTime.split(":")[0] + 12 : +tripTime.split(":")[0]) +
        ":" +
        tripTime.split(":")[1].split(" ")[0];
      const today = new Date();
      let bookingTime =
        today.getFullYear() +
        "-" +
        (today.getMonth() + 1) +
        "-" +
        today.getDate() +
        " " +
        today.getHours() +
        ":" +
        today.getMinutes();
      let myTripDate = tripDate;
      if (tripDate.toLowerCase() === "today")
        myTripDate =
          today.getFullYear() +
          "-" +
          (today.getMonth() + 1) +
          "-" +
          today.getDate();
      else if (tripDate.toLowerCase() === "tomorrow") {
        const tomorrow = new Date(today);
        tomorrow.setDate(tomorrow.getDate() + 1);
        myTripDate =
          tomorrow.getFullYear() +
          "-" +
          (tomorrow.getMonth() + 1) +
          "-" +
          tomorrow.getDate();
      }
      sendRequest(
        {
          url: "/createupdateschedulebooking",
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: {
            emailid: localStorage.getItem("user"),

            BookingDateTime: bookingTime,
            BookingID: "",

            BookingType: "Schedule",
            City: "Ahmedabad",
            CorporateID:
              localStorage.getItem("roleId") === "2"
                ? localStorage.getItem("corpId")
                : selectedCorporateDetails.cpId,
            Country: "India",
            currency: "INR",
            DropoffAddress: bookingDetails.drop
              ? bookingDetails.drop
              : bookingDetails.pickup,
            DropOffDateTime: "",
            DropoffLatitude: bookingDetails.dropLat
              ? bookingDetails.dropLat
              : bookingDetails.pickupLat,
            DropoffLongitude: bookingDetails.dropLng
              ? bookingDetails.dropLng
              : bookingDetails.pickupLng,
            GuestMobileNumber: isdCode + guestDetails.number,

            GuestName: guestDetails.name,
            LocalAmount: "0.00",
            MobileNumber: "91" + guestDetails.number + "-01",
            OtpTollChargeTrip: "0",
            OtpOnEndTrip: isOTPEnabled ? "1" : "0",
            OtpOnParkingTrip: "0",
            OtpOnStartTrip: isOTPEnabled ? "1" : "0",
            PickupAddress: bookingDetails.pickup,
            PickupDateTime: myTripDate + " " + convertedTime,
            PickupLatitude: bookingDetails.pickupLat,
            PickupLongitude: bookingDetails.pickupLng,
            VehicleType: cabBookingClicked,
            WalletUniqueID: localStorage.getItem("corpId"),

            Justification:
              servicesTabbarValue == "0"
                ? "City Ride"
                : servicesTabbarValue == "1"
                ? "Out Station"
                : "Rental " + bookingDetails.package,
          },
        },
        rideStatus
      );
    }
  }, [isConfirmRide, sendRequest, tripDate, tripTime, servicesTabbarValue, isOTPEnabled, isdCode]);

  const cabBookingHandlerClicked = (cabType) => {
    setCabBookingClicked(cabType);
    setFormError((prev) => ({
      ...prev,
      vehicleTypeError: "",
    }));
  };

  // Check if today should be removed from dates (if it's after 7 PM)
  useEffect(() => {
    const currentDate = new Date();
    if (currentDate.getHours() >= 19 && Dates.includes("Today")) {
      Dates.shift();
    }
  }, []);

  const tripDateChangeHandler = (e) => {
    const dateObj = new Date();
    let currentDate = dateObj.getDate();
    let i = 0;
    while (currentDate === dateObj.addMinutes(30).getDate()) {
      if (i === 0) {
        if (e.target.value.toLowerCase() === "today") dateObj.addHours(3);
        else {
          dateObj.setDate(dateObj.getDate() + 1);
          dateObj.setMinutes(0);
          dateObj.setHours(0);
          currentDate = dateObj.getDate();
        }
        dateObj.setMinutes(0);
      }
      times[i] =
        (+dateObj.getHours() > 12 ? dateObj.getHours() - 12 : dateObj.getHours()) +
        ":" +
        (i === 0
          ? "00"
          : dateObj.getMinutes() == "0"
          ? "0" + dateObj.getMinutes()
          : dateObj.getMinutes()) +
        (+dateObj.getHours() >= 12 ? " PM" : " AM");
      i++;
    }
    times.length = i;
    if (e.target.value) {
      isError = false;
      setFormError((prev) => ({ ...prev, pickupDateError: "" }));
    }
    setTripDate(e.target.value);
  };

  const tripTimeChangeHandler = (e) => {
    if (e.target.value) {
      isError = false;
      setFormError((prev) => ({ ...prev, pickupTimeError: "" }));
    }
    setTripTime(e.target.value);
  };

  const packageTypeChangeHandler = (e) => {
    if (e.target.value) {
      isError = false;
      setFormError((prev) => ({ ...prev, rentalPackageError: "" }));
    }
    setPackageType(e.target.value);
  };

  useEffect(() => {
    const updateIsdCodeFromDOM = () => {
      const newIsdCode = document.querySelector("#isd-code-field")?.value;
      if (newIsdCode) setIsdCode(newIsdCode);
    };

    const isdCodeField = document.querySelector("#isd-code-field");
    isdCodeField?.addEventListener("change", updateIsdCodeFromDOM);

    return () => {
      isdCodeField?.removeEventListener("change", updateIsdCodeFromDOM);
    };
  }, []);

  return (
    <React.Fragment>
      <div className="booking-main" style={{ fontFamily: "Montserrat" }}>
        <div className="booking-container">
          {/* Left Side - Form */}
          <div className="booking-form-container">
            <div className="booking-form-content">
              <div className="booking-title" style={{ fontSize: "16px", fontWeight: 600, color: "#333" }}>SCHEDULE CREATION</div>
              <Autocomplete
                disablePortal
                id="combo-box-demo"
                options={corporatesData}
                getOptionLabel={(data) => data.cpName}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    variant="standard"
                    placeholder="Search Corporate Name"
                    label="Corporate Name"
                  />
                )}
                onChange={(e, newValue) =>
                  corporateNameClickHandler(e, newValue)
                }
                defaultValue={
                  localStorage.getItem("roleId") === "2"
                    ? { cpName: localStorage.getItem("cpName") }
                    : { cpName: selectedCorporateDetails.cpName ?? "" }
                }
                disabled={localStorage.getItem("roleId") === "2" ? true : false}
              />
              <TextField
                className="standard-basic"
                defaultValue={guestDetails.name}
                error={!!formError.guestNameError}
                helperText={formError.guestNameError}
                onBlur={(e) => (guestDetails.name = e.target.value)}
                onChange={(e) => {
                  if (e.target.value) {
                    isError = false;
                    setFormError((prev) => ({ ...prev, guestNameError: "" }));
                  }
                }}
                label="Guest Name"
                variant="standard"
                inputRef={guestNameInputRef}
                autoComplete="off"
              />

              <MobileNumberFieldWithCountryCode
                className="standard-basic"
                defaultValue={guestDetails.number}
                onChange={(e) => {
                  guestDetails.number = e.target.value;
                  if (e.target.value) {
                    isError = false;
                    setFormError((prev) => ({ ...prev, guestNumberError: "" }));
                  }
                }}
                onBlur={(e) => (guestDetails.number = e.target.value)}
                onCountryCodeChange={(code) => setIsdCode(code)}
                error={!!formError.guestNumberError}
                helperText={formError.guestNumberError}
                inputRef={guestNumberInputRef}
                label="Guest Mobile Number"
                variant="standard"
                defaultCountryCode={`+${isdCode}`}
              />

              <FormControl
                variant="standard"
                sx={{ m: 1, minWidth: 120, margin: "0" }}
              >
                <InputLabel id="booking-type-select-standard-label">
                  Booking Type
                </InputLabel>
                <Select
                  labelId="booking-type-select-standard-label"
                  id="booking-type-select-standard"
                  value={servicesTabbarValue}
                  onChange={(e) => setServicesTabbarValue(e.target.value)}
                  label="Booking Type"
                >
                  <MenuItem value={0}>City Ride</MenuItem>
                  <MenuItem value={1}>Outstation</MenuItem>
                  <MenuItem value={2}>Rentals</MenuItem>
                </Select>
              </FormControl>

              <TextField
                id="pac-input1"
                defaultValue={bookingDetails.pickup}
                error={!!formError.pickupLocationError}
                helperText={formError.pickupLocationError}
                onBlur={(e) => (bookingDetails.pickup = e.target.value)}
                onChange={(e) => {
                  if (e.target.value) {
                    isError = false;
                    setFormError((prev) => ({
                      ...prev,
                      pickupLocationError: "",
                    }));
                  }
                }}
                className="standard-basic"
                label="Pickup Location"
                variant="standard"
                inputRef={pickupInputRef}
                autoComplete="off"
              />
              <TextField
                id="pac-input2"
                style={{ display: servicesTabbarValue == "2" ? "none" : "" }}
                defaultValue={bookingDetails.drop}
                error={!!formError.dropLocationEror}
                helperText={formError.dropLocationEror}
                onBlur={(e) => (bookingDetails.drop = e.target.value)}
                onChange={(e) => {
                  if (e.target.value) {
                    isError = false;
                    setFormError((prev) => ({
                      ...prev,
                      dropLocationEror: "",
                    }));
                  }
                }}
                className="standard-basic"
                label="Drop Location"
                variant="standard"
                inputRef={dropInputRef}
                autoComplete="off"
              />
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  gap: "8px",
                  marginTop: "-5px",
                }}
              >
                <FormControl
                  variant="standard"
                  sx={{ m: 1, minWidth: 120, margin: "0", flex: 1 }}
                  error={!!formError.pickupDateError}
                >
                  <InputLabel id="date-select-standard-label">Date</InputLabel>
                  <Select
                    labelId="date-select-standard-label"
                    id="date-select-standard"
                    value={tripDate}
                    onChange={tripDateChangeHandler}
                    label="Date"
                    onBlur={(e) => (bookingDetails.date = e.target.value)}
                  >
                    {Dates.map((val) => (
                      <MenuItem key={val} value={val}>
                        {val}
                      </MenuItem>
                    ))}
                  </Select>
                  <FormHelperText>{formError.pickupDateError}</FormHelperText>
                </FormControl>
                <FormControl
                  variant="standard"
                  sx={{ m: 1, minWidth: 120, margin: "0", flex: 1 }}
                  error={!!formError.pickupTimeError}
                >
                  <InputLabel id="time-select-standard-label">Time</InputLabel>
                  <Select
                    labelId="time-select-standard-label"
                    id="time-select-standard"
                    value={tripTime}
                    onChange={tripTimeChangeHandler}
                    label="Time"
                    onBlur={(e) => (bookingDetails.time = e.target.value)}
                  >
                    {times?.map((val) => (
                      <MenuItem key={val} value={val}>
                        {val}
                      </MenuItem>
                    ))}
                  </Select>
                  <FormHelperText>{formError.pickupTimeError}</FormHelperText>
                </FormControl>
              </div>
              {servicesTabbarValue == "2" && (
                <FormControl
                  variant="standard"
                  sx={{ m: 1, minWidth: 120, margin: "0", marginTop: "-5px" }}
                  error={!!formError.rentalPackageError}
                >
                  <InputLabel id="package-select-standard-label">
                    Select Package
                  </InputLabel>
                  <Select
                    labelId="package-select-standard-label"
                    id="package-select-standard"
                    label="Journey Type"
                    value={packageType}
                    onChange={packageTypeChangeHandler}
                    onBlur={(e) => (bookingDetails.package = e.target.value)}
                  >
                    {packageList.map((val) => (
                      <MenuItem key={val} value={val}>
                        {val}
                      </MenuItem>
                    ))}
                  </Select>
                  <FormHelperText>
                    {formError.rentalPackageError}
                  </FormHelperText>
                </FormControl>
              )}

              <FormControl
                variant="standard"
                sx={{ m: 1, minWidth: 120, margin: "0", marginTop: "5px" }}
                error={!!formError.vehicleTypeError}
              >
                <InputLabel id="vehicle-type-select-standard-label">
                  Vehicle Type
                </InputLabel>
                <Select
                  labelId="vehicle-type-select-standard-label"
                  id="vehicle-type-select-standard"
                  value={cabBookingClicked || ""}
                  onChange={(e) => cabBookingHandlerClicked(e.target.value)}
                  label="Vehicle Type"
                >
                  <MenuItem value="Basic">Basic (WagonR, Micra, Celerio)</MenuItem>
                  <MenuItem value="Comfort">Comfort (Dzire, Excent, Etios)</MenuItem>
                  <MenuItem value="Comfort Plus">Comfort Plus (Ertiga, Enjoy)</MenuItem>
                </Select>
                <FormHelperText>{formError.vehicleTypeError}</FormHelperText>
              </FormControl>
            </div>
          </div>

          {/* Right Side - Map */}
          <div className="booking-map-container">
            <div id="schedule-booking-map" className="booking-map"></div>
            <div className="booking-map-footer">
              <div className="booking-footer-content">
                <div className="booking-otp-section">
                  <FormControlLabel
                    sx={{ color: "gray", margin: 0 }}
                    onChange={() => setIsOtpEnabled((prev) => !prev)}
                    control={<Checkbox checked={isOTPEnabled} size="small" />}
                    label="Enable OTP Authentication for Trip"
                  />
                  {isOTPEnabled && (
                    <span className="tripOtpTextInline">
                      * OTP will be sent to Guest Mobile Number
                    </span>
                  )}
                </div>
                <div className="booking-submit-buttons">
                  <Button
                    variant="outlined"
                    onClick={() => window.history.back()}
                    style={{ marginRight: "10px" }}
                    size="small"
                  >
                    Back
                  </Button>
                  <Button
                    variant="contained"
                    onClick={() => setIsConfirmRide(true)}
                    disabled={isLoading}
                    size="small"
                  >
                    Submit
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {isLoading && (
        <Backdrop
          sx={{
            color: "rgba(34, 137, 203, 255)",
            zIndex: (theme) => theme.zIndex.drawer + 1,
          }}
          open={isLoading}
        >
          <CircularProgress color="inherit" />
        </Backdrop>
      )}
      {isBookingSuccess && (
        <Message
          type={isBookingSuccess}
          message="Your booking has been successful"
          url="/schedule-booking/bookings"
        />
      )}
    </React.Fragment>
  );
};

export default NewBooking;
